const apiGaudi = `https://${process.env.REACT_APP_API_GAUDI}/personafisica/connect/`;

export const configuracionGaudi = {
  clienteOAuth2: process.env.REACT_APP_CLIENTE_OAUTH2,
  scopeCliente: "cic",
  suscriptor: "cic",
  rutaRedireccionInicio: `https://${process.env.REACT_APP_DOMINIO}/cic_externo/autenticacion`,
  rutaRedireccionCerrarSesion: `https://${process.env.REACT_APP_DOMINIO}/cic_externo/SesionDesconectada`,
  rutaRedireccionCerrarSesionAccesoDenegado: `https://${process.env.REACT_APP_DOMINIO}/cic_externo/Error/AccesoDenegadoSistema`,
  apiAutenticador: apiGaudi + "authorize?",
  apiObtengaAccessToken: apiGaudi + "token?",
  apiCerrarSesion: apiGaudi + "endsession?",
};
